import TermCreateEdit from "../AdminTermCreateEdit";

export default class AdminTermCreateEditNotificationChannel extends TermCreateEdit {
    /**
     * @returns {string} The term type.
     */
    getType() {
        return "notification_channel";
    }
}
